import { ProductRelationshipProductPair } from 'src/app/models/interfaces/ProductRelationshipProductPair';
import { Attribute } from '../../Attribute';
import { AttributeValue } from '../../AttributeValue';
import { AttributeSettingsController, AttributeWithAttributeChildren } from '../AttributeSettingsController';
import { AttributeSettingsDTO } from '../../../DTOs/AttributeSettingsDTO';
import { AttributePair, Product } from '../../Product';
import { ProductBlueprint } from '../../ProductBlueprint';
import { AttributeInstance } from '../AttributeInstances/AttributeInstance';

export type AttributeValueOrNumber = AttributeValue | number;

export class AttributeValueInstance<T extends AttributeValueOrNumber> {
  protected _attributeValue: T;
  protected _attributeSettings?: AttributeSettingsController;

  public get attributeValueId() {
    if (this._attributeValue instanceof AttributeValue) {
      return this._attributeValue.id;
    }
    return undefined;
  }

  public get attributeValue() {
    return this._attributeValue;
  }

  public get attributeWasSet$() {
    return this._attributeSettings?.attributeWasSet$;
  }

  constructor(attributeValue: T) {
    this._attributeValue = attributeValue;
    if (attributeValue instanceof AttributeValue && attributeValue.attributes.length > 0) {
      this._attributeSettings = new AttributeSettingsController(attributeValue.attributes);
    }
  }

  public setAttributeValueAsApplied(attribute: Attribute) {
    this._attributeSettings?.setAttributeValueAsApplied(attribute);
  }

  public checkIfAttributesAreApplied() {
    return this._attributeSettings ? this._attributeSettings.checkIfAttributesAreApplied() : true;
  }

  /* public setAttributeChildren(attribute: Attribute, products: ProductRelationshipProductPair[]) {
    if (this._attributeSettings) {
      this._attributeSettings.setAttributeChildren(attribute, products);
    }
  } */

  public generateAttributeSettingsDTO(returnArray: AttributeSettingsDTO[]) {
    if (this._attributeSettings) {
      this._attributeSettings.generateAttributeSettingsDTO(returnArray);
    }
  }

  public setDefaultAttributes(overrideAttributes: AttributePair[]) {
    if (this._attributeSettings) {
      this._attributeSettings.setDefaultAttributeValues(overrideAttributes);
    }
  }

  public setAttribute(attribute: Attribute, attributeValue: AttributeValueOrNumber, priority: number) {
    if (this._attributeSettings) return this._attributeSettings.setAttribute(attribute, attributeValue, priority);
    return false;
  }

  public dispose() {
    this._attributeSettings?.dispose();
  }

  public reApplyAttributes() {
    this._attributeSettings?.reApplyAttributes();
  }

  /* public getAttributeChildren(attribute: Attribute, attributeChildren: ProductRelationshipProductPair[]) {
    return this._attributeSettings?.getAttributeChildren(attribute, attributeChildren);
  } */

  public generateAttributePairs(attributePairs: AttributePair[]) {
    this._attributeSettings?.generateAttributePairs(attributePairs);
  }

  public getAttributeValueFromAttribute(attribute: Attribute) {
    return this._attributeSettings?.getAttributeValueFromAttribute(attribute);
  }

  public referenceAttributesCanBeAppliedToProductBlueprint(productBlueprint: ProductBlueprint) {
    if (this._attributeValue instanceof AttributeValue) {
      if (!productBlueprint.containsAttributeValue(this._attributeValue)) {
        return false;
      }
    }
    if (!this._attributeSettings) return false;
    return this._attributeSettings.referenceAttributesCanBeAppliedToProductBlueprint(productBlueprint);
  }

  public findGlobalAttributes(attributeInstances: AttributeInstance<Attribute>[]) {
    this._attributeSettings?.findGlobalAttributes(attributeInstances);
  }

  public generateAttributeMap() {
    return this._attributeSettings?.generateAttributeMap();
  }

  /* public getAllAttributeChildren(attributeWithAttributeChildren: AttributeWithAttributeChildren[]) {
    this._attributeSettings?.getAllAttributeChildren(attributeWithAttributeChildren);
  } */
}
